module.exports = __webpack_public_path__ + "img/ian_popup.5925a6c0.jpg";